const createNodes = (htmlString, initialTag) => {
  const filteredString = htmlString.replaceAll('&nbsp;', ' ')
  const regex = new RegExp(`<${initialTag}>(.*?)</${initialTag}>`, 'gs')
  const matches = [...filteredString.matchAll(regex)]

  if (matches.length === 0) {
    return [{ value: filteredString }]
  } else {
    return matches.map((match) => {
      const inner = match[1]
      return {
        tag: initialTag,
        children: decomposeStrongString(inner)
      }
    })
  }
}

const decomposeStrongString = (string) => {
  const o = string.indexOf('<strong>')
  const c = string.indexOf('</strong>')
  if (o === -1) return [{ value: string }]
  else {
    const beforeStrong = string.slice(0, o)
    const strong = string.slice(o + 8, c)
    const afterStrong = string.slice(c + 9)
    const arr = [{ tag: 'strong', value: strong }]
    if (beforeStrong) arr.unshift({ value: beforeStrong })
    if (afterStrong) return [...arr, ...decomposeStrongString(afterStrong)]
    return arr
  }
}

export { createNodes, decomposeStrongString }
